import { CmtsAdminIdentityPage } from "../components/admin/index.js";
import { cmtsUsersAdminIdentityConfig } from "../config/adminIdentity.config.js";

export function CmtsUsersPage() {
  return <CmtsAdminIdentityPage config={cmtsUsersAdminIdentityConfig} />;
}

export default CmtsUsersPage;
